import PopoverContainer from "../../Componant/Ui Kit/Popover";

const Popover = () => {
  return (
    <div className="page-body">
      <PopoverContainer />
    </div>
  );
};

export default Popover;
